import { render, staticRenderFns } from "./BuyRecordsIndex.vue?vue&type=template&id=c4880fa6&scoped=true"
import script from "./BuyRecordsIndex.vue?vue&type=script&lang=js"
export * from "./BuyRecordsIndex.vue?vue&type=script&lang=js"
import style0 from "./BuyRecordsIndex.vue?vue&type=style&index=0&id=c4880fa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4880fa6",
  null
  
)

export default component.exports